import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export const useGetKioskPackets = (companyId: string) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetPacketsKioskQuery({
    request: { companyId },
    options: { enabled: !!companyId },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  return {
    packets: data?.packets || [],
    isLoading,
    isError,
  };
};
